async function storeLocator() { 
    const { Map } = await google.maps.importLibrary("maps");
    /**************************/
    /***** VARS / CONSTS ******/
    /**************************/
    const $map = document.getElementById("map");
    let map = null;
    let icon = {
        url: _vars.pin.path,
        anchor: new google.maps.Point(_vars.pin.width / 2, _vars.pin.height)
    };
    let infowindow = new google.maps.InfoWindow({
        content: ""
    });
    /**********************/
    /******* INIT *******/
    /**********************/
    $map.classList.add('loading');
    // map
    map = new Map($map, {
        center: { lat: 48.57546899206093, lng: 7.4824140637786964 },
        zoom: (window.innerWidth > 768) ? 8 : 5,
    });

    bounds = new google.maps.LatLngBounds();
    _vars.points.forEach(function(point, i){
        if(point.latlng){
            var latlnga = point.latlng.split(';');
            var latlng = new google.maps.LatLng(parseFloat(latlnga[0]), parseFloat(latlnga[1]));
            var marker = new google.maps.Marker({
                position: latlng,
                icon: icon
            });
            marker.setMap(map);
            marker.addListener("click", function() {
                var reg = /{{([^}]+)}}/; var match = null;
                var content = _vars.infowindow;
                while ((match = content.match(reg)) != null) {
                    var replace = typeof point[match[1]] != 'undefined' ? point[match[1]] : '';
                    content = content.replace(reg, replace);
                }
                infowindow.setContent(content);
                infowindow.open({
                    anchor: marker,
                    map
                });
            });
            bounds.extend(latlng);
        }        
    });
    if(_vars.points.length > 0){
        map.fitBounds(bounds);
        map.panToBounds(bounds);
    }    

    $map.addEventListener("click", function(e){
        const target = e.target.closest(".close"); 
        if(target){
            infowindow.close();
        }
    });

    $map.classList.remove('loading');
};
window.storeLocator = storeLocator;